import { Deserializable } from '../protocols/deserializable';
import { Conversation } from '@mobilefirstdev/chat-interface';
import { BudBotUserQuery } from './bud-bot-user-query';
import { BudBotLanguageModelResponse } from './bud-bot-language-model-response';
import { exists } from '../../functions/exists';

export class BudBotConversation extends Conversation implements Deserializable {
  override messages?: (BudBotUserQuery | BudBotLanguageModelResponse)[];
  onDeserialize() {
    this.messages = this.messages?.flatMap(msg => {
      if (exists((msg as any)?.response)) {
        return [
          window?.injector?.Deserialize.instanceOf(BudBotUserQuery, msg),
          window?.injector?.Deserialize.instanceOf(BudBotLanguageModelResponse, msg)
        ];
      } else {
        return [window?.injector?.Deserialize.instanceOf(BudBotUserQuery, msg)];
      }
    });
    this.summarizedName = this.summarizedName ?? 'Hello, how can I help?';
  }
}
